import React, { useState } from "react";
import "./slider.scss"; // Import your CSS file
import { Rate } from "antd";

const Slider = ({ slides }) => {
  const [isCurrentSlide, setCurrentSlide] = useState(0);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     // Move to the next slide
  //     nextSlide();
  //   }, 3000); // Adjust the interval as needed

  //   return () => clearInterval(intervalId); // Cleanup on component unmount
  // }, [slides.length]);

  const translateValue = -isCurrentSlide * 100;

  const nextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prevSlide) => (prevSlide - 1 + slides.length) % slides.length
    );
  };
  return (
    <div className="slider-container">
      <div
        className="slides"
        style={{
          transform: `translateX(${translateValue}%)`,
          transition: "transform 0.5s ease",
        }}
      >
        {slides?.map((slide, index) => (
          <div key={index} className="slide">
            <h2>{slide.dataName}</h2>
            <p>
              These readings have provided insights into my ex and helped me
              understand <br /> what went wrong. That was truly helpful!
            </p>
            <div className="ratingsSlide">
              <div className="rating">
                {
                  <div className="stars">
                    {" "}
                    <Rate disabled defaultValue={slide.rating} />
                  </div>
                }
                <h5>{slide.userId ? slide.userId.userName : "Anonymous"}</h5>
              </div>
              <div className="arrows">
                <img
                  src={
                    require("../../assets/svgs/small-icons/left-arrow.svg")
                      .default
                  }
                  alt="arrow"
                  onClick={() => {
                    prevSlide();
                  }}
                />
                <img
                  src={
                    require("../../assets/svgs/small-icons/right-arrow.svg")
                      .default
                  }
                  alt="arrow"
                  onClick={() => {
                    nextSlide();
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Slider;
